<template>
  <div class=''>
    <VueDraggableResizable
        :x='xPopup'
        :y='yPopup'
        :w='widthPopup'
        :h='heightPopup'
        @deactivated='onClosePlagPopup'
        :active='true'
        id='popupPlag'
        class='popupPlag'
        style='z-index: 2000; cursor: move;'
    >
      <div class='plag_popup'>
        <!--                Header-->
        <div class='popup-header'>
          <p class='plagiarism-id'>{{ noPlagCurrentPopup }}</p>

          <div class='plagiarism-title-container'>
            <div
                v-if="!resultPlagCurrentPopup['isIgnoredBySystem']"
                style='height: 100%;'
            >
              <div v-if="!resultPlagCurrentPopup['isIgnored']">
                <div
                    style='width: 100%;'
                >
                  <el-tooltip
                      v-if='documentType === DocumentSourceType.WEB || documentType === DocumentSourceType.GROUP'
                      class='item'
                      effect='dark'
                      :content='currentSimilarSource.title'
                      placement='bottom'
                      :open-delay='500'
                  >
                    <a :href="currentSimilarSource['url']"
                       class='disable_decorate plagiarism-title'
                       target='_blank'>
                      {{
                        currentSimilarSource.title
                      }}
                    </a>
                  </el-tooltip>
                  <el-tooltip
                      v-else
                      class='item'
                      effect='dark'
                      :content="currentSimilarSource.title.split('.')[0]"
                      placement='bottom'
                      :open-delay='500'
                  >
                    <a href='#'
                       class='disable_decorate plagiarism-title'
                       target='_blank'>
                      {{
                        currentSimilarSource.title
                      }}
                    </a>
                    <!--                                        <span class="plagiarism-title">-->
                    <!--                                            {{resultPlagCurrentPopup.titleSource.split('.')[0]}}-->
                    <!--                                        </span>-->
                  </el-tooltip>
                </div>
              </div>
              <div v-else>
                                <span class='plagiarism-title'>
                                    Người dùng đã đánh dấu loại bỏ
                                </span>
              </div>
            </div>
            <div v-else>
                            <span class='plagiarism-title'>
                                Nội dung không được kiểm tra
                            </span>
            </div>
          </div>

          <button
              type='button'
              class='popup-close-btn close'
              data-dismiss='alert'
              aria-label='Close'
              @click='onClosePlagPopup'
          >
            <span aria-hidden='true' class='close-text'>×</span>
          </button>
        </div>
        <!--            End header-->
        <!--            Body-->
        <div class='popup-body scrollable local-scroller '>
          <div v-if="resultPlagCurrentPopup['isIgnoredBySystem']">
            <div>
                            <span style='color: #f00; font-weight: bold;'>
                                {{ ReasonIgnoredBySystemType[resultPlagCurrentPopup['ignoredBySystemReason']].name }}
                            </span>
            </div>
          </div>
          <div v-else-if="resultPlagCurrentPopup['isIgnored']">
            <div>
                            <span style='color: #f00; font-weight: bold;'>
                                {{ ReasonIgnoreTypes[resultPlagCurrentPopup['ignoredReason']].name }}
                            </span>
            </div>
            <!--                        <div-->
            <!--                            class="padding-right-5"-->
            <!--                            v-html="similarContent"-->
            <!--                        ></div>-->
          </div>
          <div v-else>
            <div
                class='padding-right-5'
                v-html='similarContent'
            ></div>
          </div>
        </div>
        <!--            End body-->
        <!--            Footer-->
        <div
            class='popup-footer'
            v-if="!resultPlagCurrentPopup['isIgnoredBySystem'] && !isGroupDocument"
        >
          <div
              v-if='!isIgnoredLocal'
              style='float:right'
              class='options-container'
          >
            <a v-if='isIgnoredOptions && !resultPlagCurrentPopup.isIgnored'
               tabindex='0'
               style='cursor: pointer;'
               @click='showIgnoreForm(IgnoreUserFormMode.NEW)'
               class='popup-options'
            >
              Loại bỏ kết quả
            </a>
            <div v-else>
              <a
                  @click='onShowUndoIgnoreByUserForm()'
                  tabindex='0'
                  style='cursor: pointer'
                  class='popup-options'
              >
                Xóa loại trừ
              </a>
              <a
                  @click='showIgnoreForm(IgnoreUserFormMode.EDIT)'
                  tabindex='0'
                  style='cursor: pointer;'
                  class='margin-right-15 popup-options'
              >
                Sửa thông tin loại trừ
              </a>
            </div>
          </div>
        </div>
        <!--            End footer-->
      </div>
    </VueDraggableResizable>
  </div>
</template>
<script>
import {
  DocumentSourceType,
  IgnoreUserFormMode,
  ReasonIgnoredBySystemType,
  ReasonIgnoreTypes,
  reloadGroupType
} from '@/constants/DoITConstant'
import {getDocumentSourceType, mark} from '@/helpers/StringHelper'
import {AUTHENTICATE_STORE} from '@/store/modules/AuthenticateStore'
import {mapState} from 'vuex'

export default {
  name: 'PlagiarismPopup',
  props: {
    isIgnoredOptions: {
      type: Boolean
    },
    dataImage: {
      type: Object
    },
    isGroupDocument: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      ReasonIgnoreTypes: ReasonIgnoreTypes,
      ReasonIgnoredBySystemType: ReasonIgnoredBySystemType,
      heightPopup: 250,
      widthPopup: 550,
      markIsIgnored: true,
      reasonIgnoreType: 'system_detect_wrong',
      IgnoreUserFormMode,
      DocumentSourceType
    }
  },
  async mounted() {
  },
  methods: {
    onClosePlagPopup() {
      this.$store.dispatch(
          'docRes/plagiarism/updateIsShowPlagPopup',
          false
      )
      this.$store.dispatch(
          'docRes/plagiarism/updatePlagNo',
          ''
      )
    },

    async onShowUndoIgnoreByUserForm() {
      let userInfo = this.user
      let docInfo = this.$store.getters['docRes/documentInfoCurrent']
      let isOwnerCreate = null
      if (userInfo.id === docInfo.ownerId) {
        isOwnerCreate = true
      } else {
        isOwnerCreate = false
      }


      let plagCurrentInfo = this.$store.getters[
          'docRes/plagiarism/resultPlagCurrentPopup'
          ]

      const ignoredSentenceIds = plagCurrentInfo.parts.map(part => part.sentenceId)
      let resultPlagIgnored = {
        isIgnored: false,
        sentenceIds: ignoredSentenceIds,
        reason: '',
        isOwnerCreate: isOwnerCreate,
        reasonIgnoreType: this.reasonIgnoreType,
        tsCreate: new Date().getTime(),
        userIdCreate: userInfo.id
      }

      // Updates array lstResultPlagIgnoredCurrent (data ignored by user)
      this.$store.dispatch(
          'docRes/plagiarism/updateLstResultPlagIgnoredCurrent',
          {resultPlagIgnored: resultPlagIgnored, isUndo: false}
      )

      // Hide popup "Ignored by user"
      this.$store.dispatch(
          'docRes/plagiarism/updateIsShowPlagPopup',
          false
      )

      // this.$message({
      //     message: 'Đã xóa loại bỏ',
      //     type: 'success'
      // })
      this.$emit('reload-group', {resultPlag: this.resultPlagCurrentPopup, type: reloadGroupType.ENABLE_SENTENCE})
    },
    showIgnoreForm(mode) {
      this.$emit('showIgnoreForm', mode)
    }
  },
  computed: {
    resultPlagCurrentPopup() {
      const resultPlag = this.$store.getters[
          'docRes/plagiarism/resultPlagCurrentPopup'
          ]
      resultPlag.ignoredReason = resultPlag.ignoredReason || ReasonIgnoreTypes.system_detect_wrong.type
      // console.log(resultPlag)
      return resultPlag
    },
    resultLineCurrentPopup() {
      return this.$store.getters[
          'docRes/plagiarism/resultLineCurrentPopup'
          ]
    },
    lstResultPlagIgnoredCurrent() {
      return this.$store.getters[
          'docRes/plagiarism/lstResultPlagIgnoredCurrent'
          ]
    },
    xPopup() {
      let res = (this.resultLineCurrentPopup.left * 4) / 3
      return Math.min(
          res,
          (this.dataImage.width * 4) / 3 - this.widthPopup
      )
    },
    yPopup() {
      let res = ((this.resultLineCurrentPopup.top + this.resultLineCurrentPopup.height) * 4) / 3
      // Get current position of the page container
      let elem = document.getElementById(
          'page-' + this.currentPageId + '-container'
      )
      if (elem == null) return null
      let rect = elem.getBoundingClientRect(),
          scrollTop =
              window.pageYOffset || document.documentElement.scrollTop
      let containerTop = rect.top + scrollTop
      // let containerLeft= rect.left + scrollLeft

      // Get window's height
      let body = document.body,
          html = document.documentElement
      let windowHeight = Math.max(
          body.scrollHeight,
          body.offsetHeight,
          html.clientHeight,
          html.scrollHeight,
          html.offsetHeight
      )

      // Get current container height
      let currentContainerHeight = windowHeight - containerTop

      if (res + this.heightPopup > currentContainerHeight)
        res = res - (this.resultLineCurrentPopup.height * 4) / 3 - this.heightPopup
      return res
    },
    currentPageId() {
      return this.resultPlagCurrentPopup.parts[0].highlights[0].pageId
    },
    noPlagCurrentPopup() {
      return this.$store.getters['docRes/plagiarism/noPlagCurrentPopup']
    },
    currentSimilarSource() {
      return this.$store.getters['docRes/plagiarism/getSimilarSource'](this.resultPlagCurrentPopup.similarSourceId)
    },
    documentType() {
      // const url = this.currentSimilarSource.url
      return getDocumentSourceType(this.currentSimilarSource)
    },
    similarContent() {
      let content = ''
      if (!this.resultPlagCurrentPopup.isIgnored) {
        this.resultPlagCurrentPopup.parts.forEach(part => {
          const similarity = this.similarities[part.similarityId]
          const sentence = this.$store.getters['docRes/plagiarism/getSourceSentence'](similarity.sentenceId)
          let similarSentence = this.$store.getters['docRes/plagiarism/getSimilarSentence'](part.similarSentenceId).content
          if (similarity.endSimilarCharIndex - similarity.startSimilarCharIndex > 0) {
            similarSentence = similarSentence.substr(similarity.startSimilarCharIndex, similarity.endSimilarCharIndex - similarity.startSimilarCharIndex)
          }
          content += mark(sentence.content, similarSentence)
        })
      }
      return content
    },
    similarities() {
      return this.$store.getters['docRes/plagiarism/getAllSimilarities']
    },
    isIgnoredLocal() {
      if (this.resultPlagCurrentPopup.isIgnored)
        return false
      const similarity = this.similarities[this.resultPlagCurrentPopup.parts[0].similarityId]
      return !!this.lstResultPlagIgnoredCurrent.find((e) => e.sentenceIds.includes(similarity.sentenceId))
    },
    ...mapState({
      user: (state) => state[AUTHENTICATE_STORE].user
    })
  }
}
</script>

<style>
.plag_popup {
  /*padding: 20px;*/
  /*background-color: #ecf8ff;*/
  /*height: 100%;*/
  /*border-radius: 8px;*/
  /*border: 1.2px solid #50b5f1;*/

  position: relative;
  background-color: #fafafa;
  height: 100%;
  min-height: 150px;
  min-width: 255px;
  border: solid 1px gray;
  overflow: hidden;
}

.popup-header {
  position: absolute;
  width: 100%;
  height: 50px;
  left: 0px;
  top: 0px;
  background: #ffffff;
  border-bottom: 2px solid #f5f5f5;

  /*    Debug*/
  overflow: hidden;
}

.plagiarism-id {
  position: absolute;
  width: 28px;
  height: 33px;
  left: 13px;
  top: 8px;

  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 33px;
  /* identical to box height */

  display: flex;
  align-items: center;
  text-align: center;

  color: black;
}

.plagiarism-title-container {
  position: absolute;
  /*width: 413px;*/
  width: calc(100% - 120px);
  margin-right: 40px;
  height: 25px;
  left: 70px;
  top: 12px;
  display: flex;
}

.plagiarism-title {
  width: 100%;
  position: absolute;
  font-size: 18px;
  line-height: 25px;
  /* identical to box height */
  align-items: center;
  color: red;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.popup-close-btn {
  position: absolute;
  width: 14px;
  height: 33px;
  right: 20px;
  top: 7px;
  display: flex;
}

.close-text {
  font-weight: bold;
  font-size: 24px;
  line-height: 33px;
  align-items: center;
  text-align: center;
  color: #7e7e7e;
}

.popup-body {
  position: absolute;
  width: calc(100% - 18px);
  height: calc(100% - 100px);
  left: 15px;
  top: 65px;

  font-size: 14px;
  line-height: 160%;
}

.popup-footer {
  position: absolute;
  height: 41px;
  width: 100%;
  left: 0;
  bottom: 0;

  background: #ffffff;
  /*box-shadow: 0 -1px 4px rgba(0, 0, 0, 0.25);*/
  /*border-top: 1px solid gray;*/
  overflow: hidden;
}

.options-container {
  position: absolute;
  width: 440px;
  height: 40px;
  right: 0;

  background: #ffffff;
}

.popup-options {
  /*width: 150px;*/
  height: 40px;
  padding-right: 10px;

  font-size: 14px;
  line-height: 160%;
  display: flex;
  align-items: center;
  text-align: center;
  float: right;
}

.active .handle {
  background: rgba(255, 255, 255, 0);
  border: 1px solid rgba(255, 255, 255, 0);
}

.active .handle-tm {
  top: -10px;
  left: 0%;
  margin-left: 0px;
  margin-right: 5px;
  width: 100%;
  cursor: n-resize;
}

.active .handle-mr {
  right: -10px;
  top: 0%;
  cursor: e-resize;
  height: 100%;
  margin-top: 0px;
}

.active .handle-ml {
  right: -10px;
  top: 0%;
  cursor: e-resize;
  height: 100%;
  margin-top: 0px;
}

.active .handle-bm {
  left: 0%;
  margin-left: 0px;
  margin-right: 5px;
  width: 100%;
  cursor: n-resize;
}

.popupPlag.vdr {
  border: none;
}
</style>
